import { defineStore } from 'pinia';
import { readonly, ref, type Ref } from 'vue';
import type { NamedEntity } from '~/domains/core';

const usePartnershipLanguageStore = defineStore('partnershipLanguage', () => {
  const selectedLanguage = ref<string>();
  const languages: Ref<NamedEntity[]> = ref([]);

  const setSelectedLanguage = (language?: string): void => {
    selectedLanguage.value = language;
  };

  const setLanguages = (newLanguages: NamedEntity[]): void => {
    languages.value = newLanguages;
  };

  const getLanguageName = (languageId: string): string | undefined => {
    const language = languages.value.find(
      (language) => language.id === languageId,
    );
    return language?.name;
  };

  return {
    selectedLanguage: readonly(selectedLanguage),
    languages: readonly(languages),
    setSelectedLanguage,
    setLanguages,
    getLanguageName,
  };
});

export default usePartnershipLanguageStore;
